import type { ErrorInfo } from 'react';

import { buildComponentErrorReport } from './internal/buildComponentErrorReport';
import { trackError } from './trackError';
import type { TrackErrorOptions } from './types';

export function trackComponentError(error: Error, info: ErrorInfo, options: TrackErrorOptions) {
  const { error: renderingError, context } = buildComponentErrorReport(error, info, options);

  trackError(renderingError, context);
}
